const disableTouchForHover =
  window.ontouchstart !== undefined ? { onMouseEnter: undefined, onMouseLeave: undefined } : {};

export default disableTouchForHover;
